/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedSalaryRequestDto } from '../../models/backend-patched-salary-request-dto';
import { BackendSalaryDto } from '../../models/backend-salary-dto';

export interface OpexesSalaryPartialUpdate$XWwwFormUrlencoded$Params {
  id: number;
  body?: BackendPatchedSalaryRequestDto;
}

export function opexesSalaryPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: OpexesSalaryPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSalaryDto>> {
  const rb = new RequestBuilder(rootUrl, opexesSalaryPartialUpdate$XWwwFormUrlencoded.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSalaryDto>;
    }),
  );
}

opexesSalaryPartialUpdate$XWwwFormUrlencoded.PATH = '/api/opexes/salary/{id}/';
